import { api, ApiRes } from './_api-client';
import { Rotate } from './file.service';

export enum ConfigFlags {
  reverse,
  flip,
  stabilization,
  brightness,
  contrast,
  volume,
  orderFirst,
  orderLast,
  panZoomRotate,
}

export enum AspectRatio {
  orig,
  is16x9,
  is9x16,
}
export type PanZoomRotateConfig = [PanZoomRotateParams | null, PanZoomRotateParams | null];

export interface PanZoomRotateParams {
  positionTime: number;
  moveX: number;
  moveY: number;
  rotate: number;
  zoom: number;
  aspectRatio: AspectRatio;
}

export interface ClipConfig {
  flags: ConfigFlags[];
  brightness: number;
  contrast: number;
  speed: number;
  volume: number;
  panZoomRotate: PanZoomRotateConfig;
  rotate: Rotate | null;
}

// Default clip configuration
export const DEFAULT_CLIP_CONFIG: ClipConfig = {
  flags: [],
  brightness: 0,
  contrast: 0,
  speed: 1,
  volume: 100,
  panZoomRotate: [null, null],
  rotate: null,
};

export interface ClipPayload {
  clipGroupId: number;
  thumbnailUrl: Url | null;
  config: ClipConfig;
  score?: number;
  highlightId?: number;
  isAutoHighlight?: boolean;
  isPinned?: boolean;
}

export interface SetClipsReq {
  storyId: StoryId;
  data: Record<ClipId, Partial<ClipPayload>>;
}

export interface SetClipThumbnailsForFinalCutReg {
  finalCutId: FinalcutId;
  data: Record<ClipId, Partial<ClipPayload>>;
}

export interface SetHighlightThumbnailReq {
  storyId: StoryId;
  data: {
    highlightId: number;
    thumbnailUrl: Url;
  };
}

export interface SetClipsRes extends ApiRes {
  data?: Record<ClipId, Url>;
}

export interface GetClipsReq {
  storyId: StoryId;
  includeAllHighlights?: boolean;
  fileId?: FileId;
}

export type GetClipsRes = Record<ClipId, ClipPayload>;

// S E R V I C E

export const removeDeletedClips = (storyId: StoryId) => {
  return api.delete<boolean>(`/Clip/RemoveDeletedClips?storyId=${storyId}`);
};

export const removeDeletedClipsByProjectId = (projectId: ProjectId) => {
  return api.delete<boolean>(`/Clip/RemoveDeletedClipsByProjectId?projectId=${projectId}`);
};

export const getClips = (payload: GetClipsReq) => {
  return api.get<GetClipsRes>(`/Clip/GetClips?${buildGetClipsParams(payload)}`);
};

export const setClips = (payload: SetClipsReq) => {
  return api.post<SetClipsRes>(`/Clip/SetClips?storyId=${payload.storyId}`, payload.data);
};

export const setClipThumbnailsForFinalCut = (payload: SetClipThumbnailsForFinalCutReg) => {
  return api.patch<SetClipsRes>(`/Clip/SetClipThumbnailsForFinalCut?finalCutId=${payload.finalCutId}`, payload.data);
};

export const setHighlightThumbnail = (payload: SetHighlightThumbnailReq) => {
  return api.patch<Url>(`/Clip/SetHighlightThumbnail?storyId=${payload.storyId}`, payload.data);
};

// H E L P E R S

const buildGetClipsParams = (payload: GetClipsReq): string => {
  const params = new URLSearchParams({ storyId: String(payload.storyId) });
  if (payload.includeAllHighlights !== undefined)
    params.append('includeAllHighlights', String(payload.includeAllHighlights));
  if (payload.fileId !== undefined) params.append('fileId', String(payload.fileId));
  return params.toString();
};
